import React from 'react';
import { Link, Typography } from '@mui/material';
import CallIcon from '@mui/icons-material/Call';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import useRUMView from 'common-datadog/useRUMView';

import Screen from '../Screen';
import usePrequal from '../../resources/prequal/usePrequal';

const dignifiPhone = '(855) 808-5861';
const dignifiEmail = 'questions@dignifi.com';

const row = {
  gap: 1,
  display: 'flex',
  justifyContent: 'center',
  fontWeight: 'bold',
};

const ManualReview = () => {
  useRUMView('fraud_victim');
  const { data: prequal } = usePrequal();

  return (
    <Screen
      header="Some of your information could not be verified."
      subheader="If you feel this is an error, contact a DigniFi representative using one of the options below."
    >
      <Typography variant="body1">
        Your Reference Application ID Number is:
        {' '}
        <b>{prequal.applicationId}</b>
      </Typography>
      <Link sx={row} underline="none" href={`tel:${dignifiPhone}`}>
        <CallIcon />
        {dignifiPhone}
      </Link>
      <Link sx={row} underline="none" href={`mailto:${dignifiEmail}`}>
        <MailOutlineIcon />
        {dignifiEmail}
      </Link>
    </Screen>
  );
};

export default ManualReview;
